import React, { useState } from "react";
import { ConfigFilterFacet, Filter } from "@usereactify/search";
import { FiltersBox } from "./FiltersBox";

import { Dropdown } from "../Dropdown/Dropdown";
import FilterContent from "./FilterContent";

type Props = {
  filter: ConfigFilterFacet;
  isDropdown: boolean;
};

export const FiltersPanel: React.FC<Props> = (props) => {
  const { filter, isDropdown } = props;
  const [isOpen, setIsOpen] = useState(false);
  const isSizeGuide = filter.id === "size_guide";

  const Title = () => <span className="font-body text-body inline-flex filter-heading">{filter.name}</span>;

  return (
    <>
      {isDropdown ? (
        <>
          <Dropdown
            btnContent={<Title />}
            dropdownIsOpen={isOpen}
            setDropdownIsOpen={setIsOpen}
            transitionDuration={300}
            dropdownContent={<FilterContent filter={filter} isSizeGuide={isSizeGuide} handleChange={setIsOpen} />}
          />
        </>
      ) : (
        <>
          <Title />
          <FilterContent filter={filter} isSizeGuide={isSizeGuide} handleChange={setIsOpen} />
        </>
      )}
    </>
  );
};
